module.exports = __webpack_public_path__ + "img/project6.75e29094.jpg";